import lodashGet from 'lodash/get';
import { api as masterApi } from '@/api/api';
import { apis, isElectron } from '@/config';
import { BRIDGE_RESPONSE_CODE, BRIDGE_RESPONSE_TYPE } from '../../interface/common';
import { CustomError } from '../../config/bridgeError';
export class MailElectronInterceptor {
    constructor(interceptors) {
        this.mailApi = masterApi.requireLogicalApi(apis.mailApiImpl);
        this.systemApi = masterApi.getSystemApi();
        const [requestInterceptor, responseInterceptor] = interceptors;
        requestInterceptor.use({
            namespace: apis.mailApiImpl,
            async resolve(config) {
                if (config.namespace !== apis.mailApiImpl || isElectron()) {
                    return config;
                }
                throw new CustomError(BRIDGE_RESPONSE_TYPE.ONLY_SUPPORT_ELECTRON, {
                    code: BRIDGE_RESPONSE_CODE.ONLY_SUPPORT_ELECTRON,
                    config: config,
                });
            },
        });
        responseInterceptor.use({
            namespace: apis.mailApiImpl,
            type: 'error',
            async resolve(res) {
                return res;
            },
            reject: async (error) => {
                const isMail = lodashGet(error, 'config.namespace', '') === apis.mailApiImpl;
                const account = lodashGet(error, 'config.account', '');
                const masterAccount = lodashGet(this.systemApi.getCurrentUser(), 'accountMd5', '');
                if (!isMail || window.isAccountBg || account !== masterAccount) {
                    throw error;
                }
                const { apiname, args } = lodashGet(error, 'config');
                if (typeof this.mailApi[`_$${apiname}`] !== 'function') {
                    throw error;
                }
                return this.mailApi[`_$${apiname}`](...args);
            },
        });
    }
    eject() { }
}
